import { render } from "./BasicFooter.vue?vue&type=template&id=10b2e956&scoped=true"
import script from "./BasicFooter.vue?vue&type=script&lang=js"
export * from "./BasicFooter.vue?vue&type=script&lang=js"

import "./BasicFooter.vue?vue&type=style&index=0&id=10b2e956&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b2e956"]])

export default __exports__